export function readFieldValue(fields: Record<string, unknown> | undefined, key: string): unknown
export function readFieldValue<T>(fields: Record<string, unknown> | undefined, key: string, fallback: T): unknown | T
export function readFieldValue<T>(fields: Record<string, unknown> | undefined, key: string, fallback?: T) {
  const resolvedFallback = (fallback === undefined ? '' : fallback) as unknown
  if (!fields) {
    return resolvedFallback
  }
  const item = fields[key] as { value?: unknown } | unknown
  if (item && typeof item === 'object' && 'value' in (item as Record<string, unknown>)) {
    const value = (item as { value?: unknown }).value
    return value === undefined || value === null || value === '' ? resolvedFallback : value
  }
  return item === undefined || item === null || item === '' ? resolvedFallback : item
}

export function normalizeFieldText(fields: Record<string, unknown> | undefined, key: string, fallback = '') {
  return String(readFieldValue(fields, key, fallback) ?? fallback).trim()
}

export function normalizeFieldBool(fields: Record<string, unknown> | undefined, key: string, fallback = false) {
  const value = readFieldValue(fields, key, fallback)
  if (typeof value === 'boolean') {
    return value
  }
  const text = String(value ?? '').trim().toLowerCase()
  if (text === 'true' || text === '1' || text === 'yes' || text === 'on') {
    return true
  }
  if (text === 'false' || text === '0' || text === 'no' || text === 'off') {
    return false
  }
  return fallback
}

export function normalizeFieldNumber(fields: Record<string, unknown> | undefined, key: string, fallback = 0) {
  const value = Number(readFieldValue(fields, key, fallback))
  return Number.isFinite(value) ? value : fallback
}

export function normalizeFieldJson<T>(fields: Record<string, unknown> | undefined, key: string, fallback: T): T {
  const raw = readFieldValue(fields, key, '')
  if (typeof raw !== 'string') {
    return raw as T
  }
  const text = raw.trim()
  if (!text) {
    return fallback
  }
  try {
    return JSON.parse(text) as T
  } catch {
    return fallback
  }
}
